import { render, staticRenderFns } from "./change-city-form.vue?vue&type=template&id=5bf02fc0&"
import script from "./change-city-form.vue?vue&type=script&lang=ts&"
export * from "./change-city-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports